var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 402",
    style: {
      enableBackground: "new 0 0 800 402"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-0.44,201.56C96.85,91.29,211.53,13.78,359.66,0.99C540.47-14.62,675.87,76.74,800,199.77 c-93.34,106.66-203.96,182.49-346.08,199.11C266.87,420.75,126.75,328.12-0.44,201.56z M256.84,199.11 c-0.6,79.01,61.95,143.72,140.08,144.9c80.02,1.21,145.43-62.36,145.84-141.72c0.4-79.98-63.46-144.98-142.66-145.21 C321.83,56.86,257.43,120.72,256.84,199.11z M49.47,199.78c71.64,68.13,148.05,122.58,242.75,148.02 c-46.19-40.14-72.33-88.91-71.41-150.63c0.93-61.92,30.37-109.23,77.29-147.91C200.51,74.04,120.98,126.51,49.47,199.78z  M506.51,52.41c95.16,77.75,100.84,217.42-10.6,303.1c102.65-27.85,183.23-80.61,254.12-153.86 C678.35,133.09,601.05,78.71,506.51,52.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.48,112.95c-21.13,27.72-20.94,49.2-0.68,63.86c20.13,14.56,39.87,7.77,61.11-21c23,34.89,18.18,79.27-11.85,109.09 c-30.76,30.55-77.36,35.53-113.42,12.12c-36.21-23.51-51.08-68.55-35.8-108.39C330.57,127.63,369.99,105.02,415.48,112.95z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M779.89,87.96L53.03,397.1c-15.66,6.66-33.75-0.64-40.41-16.29l-7.19-16.91c-6.66-15.66,0.64-33.75,16.29-40.41 L748.58,14.34c15.66-6.66,33.75,0.64,40.41,16.29l7.19,16.91C802.85,63.21,795.55,81.3,779.89,87.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosedEye);
export default __webpack_public_path__ + "static/media/IconClosedEye.7fec85c34040ccf0d3e7058a4b7a4780.svg";
export { ForwardRef as ReactComponent };